import React, { useState } from "react";
import style from "../../main/components/MainPC/index.module.scss";
import localStyle from "./index.module.scss";
import { Link } from "react-router-dom";
import List from "./components/List";
import BatchPicker from "../../main/components/MainPC/components/BatchPicker";

// 课程列表页面
function CourseList() {
    const [open, setOpen] = useState(false);

    return (
        <div className={style.root}>
            <div className={style.header}>
                <BatchPicker />
                <div className={style.flex}>
                    <div
                        className={localStyle.addCourse}
                        onClick={() => setOpen(true)}>
                        加入课程
                    </div>
                    <Link className={localStyle.scheduleLink} to={"/"}>
                        <span>课程表</span>
                    </Link>
                </div>
            </div>
            <div className={localStyle.list}>
                <List open={open} onCancel={() => setOpen(false)} />
            </div>
        </div>
    );
}

export default CourseList;
